import React, { useMemo } from 'react';
import { useCurrentUser } from '../../../contexts/CurrentUser';
import { useTranslation } from 'react-i18next';
import { platformNamesMapping, platformMapping, availablePlatforms} from '../../../utils/platforms';
import { ContentContainer } from '../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../components/Filters/components/ControlsPanel';
import { CheckboxList } from '../../../components/Filters/components/CheckboxList';
import { platformIconsCircleMapping } from '../../../utils/platforms';
import { ReactComponent as WebIcon } from '../../../assets/web.svg';
import { useSearchContext } from '../contexts';

export const PlatformChooser = () => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const { state, updateDraftFilters } = useSearchContext();
  const workspaceConfig = currentUser?.workspace?.config;
  const availablePlatformsConfig = workspaceConfig?.available_platforms || [];

  const selected = state.draftFilters.platforms.value;

  let platformList: { name: string; value: number | string, icon: React.ReactNode }[] = [];
  
  if (availablePlatformsConfig?.length > 0) {
    platformList = availablePlatformsConfig.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platformMapping[platform] || platform,
      icon: platformIconsCircleMapping[platform] || <WebIcon />,
    }));
  }
  else {
    platformList = availablePlatforms.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platformMapping[platform] || platform,
      icon: platformIconsCircleMapping[platform] || <WebIcon />,

    }));
  }

  const handleSelectAll = () => {
    updateDraftFilters({
      platforms: {
        value: platformList.map(p => Number(p.value)),
        exclude: state.draftFilters.platforms.exclude
      }
    });
  };

  const handleClearAll = () => {
    updateDraftFilters({
      platforms: {
        value: [],
        exclude: false
      }
    });
  };

  const handleTogglePlatform = (platformValue: number) => {
    if (selected.includes(platformValue)) {
      updateDraftFilters({
        platforms: {
          value: selected.filter(s => s !== platformValue),
          exclude: state.draftFilters.platforms.exclude
        }
      });
    } else {
      updateDraftFilters({
        platforms: {
          value: [...selected, platformValue],
          exclude: state.draftFilters.platforms.exclude
        }
      });
    }
  };

  // Memoize the checkbox items to prevent recreating on every render
  const checkboxItems = useMemo(() => {
    return platformList.map(platform => ({
      name: platform.name,
      checked: selected.includes(Number(platform.value)),
      onChange: () => handleTogglePlatform(Number(platform.value)),
      disabled: false,
      icon: platform.icon,
    }));
  }, [platformList, selected]);

  return(
    <ContentContainer
      searchComponent={null}
      actionsComponent={
        <ControlsPanel
          id='platform-filter'
          count={selected.length}
          isExclude={false}
          showExcludeSwitch={false}
          showSelectAll={true}
          isSelectAllDisabled={platformList.length === selected.length}
          onClearAll={handleClearAll}
          onSelectAll={handleSelectAll}
          onExcludeClick={() => {}}
        />
      }
      badgesComponent={null}
    >
      <CheckboxList items={checkboxItems} />
    </ContentContainer>
  );
};
